import * as React from "react";

function SvgCJ(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 801 801"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{`.cj-1{fill:#025450;}.cj-2{fill:#fff;}`}</style>
      </defs>
      <path
        className="cj-1"
        d="M400.5,.43C179.94,.43,.48,179.84,.48,400.43s179.47,400,400.02,400,399.98-179.44,399.98-400S621.05,.43,400.5,.43Z"
      />
      <path
        className="cj-2"
        d="M600.49,288.45h-237.18c-3.14,0-5.8,2.25-6.33,5.34l-11.08,64.99c-.32,1.87,.2,3.78,1.42,5.22,1.22,1.45,3.01,2.28,4.91,2.28h152.08c3.17,0,6.17,1.39,8.22,3.82,2.05,2.42,2.92,5.61,2.38,8.74l-26.05,152.8c-4.38,25.71-28.88,46.62-54.6,46.62h-120.35c-3.14,0-5.81,2.25-6.33,5.34l-11.08,65c-.32,1.87,.2,3.78,1.42,5.22,1.22,1.45,3.01,2.28,4.91,2.28h117.42c69.02,0,134.75-56.16,146.52-125.19l40.06-234.97c.32-1.87-.2-3.78-1.42-5.22s-3.01-2.28-4.91-2.28Z"
      />
      <path
        className="cj-2"
        d="M425.75,507.06l11.08-65c.32-1.87-.2-3.78-1.42-5.22-1.22-1.45-3.01-2.28-4.91-2.28h-117.42c-12.48,0-23.46-4.86-30.91-13.69-7.59-9-10.58-20.95-8.41-33.66l20.12-118.01c4.38-25.71,28.87-46.62,54.6-46.62h120.35c3.14,0,5.8-2.25,6.33-5.34l11.08-65c.32-1.87-.2-3.78-1.43-5.23s-3.01-2.28-4.91-2.28h-117.42c-69.02,0-134.75,56.16-146.52,125.19l-20.12,118.01c-5.72,33.57,2.09,65.05,22,88.64,19.5,23.1,48.34,35.83,81.22,35.83h120.35c3.14,0,5.81-2.25,6.33-5.34Z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCJ);
